import { render, staticRenderFns } from "./PhoneNumberInput.vue?vue&type=template&id=023576fc&scoped=true&"
import script from "./PhoneNumberInput.vue?vue&type=script&lang=ts&"
export * from "./PhoneNumberInput.vue?vue&type=script&lang=ts&"
import style0 from "./PhoneNumberInput.vue?vue&type=style&index=0&id=023576fc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023576fc",
  null
  
)

export default component.exports